export const GA_EVENT_FAQ_INGRESS = '>>INGRESS<<';
export const GA_EVENT_TYPE_FAQ = 'DL_FAQ_EVENT';
export const GA_EVENT_DOWNLOAD_APP = 'Open App';
export const GA_EVENT_OPEN_DOWNLOAD_BANNER = 'Banner Active';
export const GA_EVENT_CLOSE_DOWNLOAD_BANNER = 'Close App';
export const GA_EVENT_BACK_TO_HOME_PAGE_ERROR = 'Back to Home from Error Page';
export const GA_EVENT_BACK_TO_HOME_PAGE_EXPIRED =
  'Back to Home from Expired Page';
